<div
	class="title title-padding flex items-center division-line border-b-1 border-solid lg:mb-4 gap-2"
>
	<mat-icon
		*ngIf="showBack"
		class="mdi mdi-chevron-left text-xl leading-5 cursor-pointer shrink-0"
		(click)="onBack()"
	></mat-icon>
	<div class="flex flex-col leading-tight min-w-0 flex-1">
		<span *ngIf="subtitle" class="text-xs text-gray-700 font-medium italic truncate">{{ subtitle }}</span>
		<span class="max-[1023px]:!text-base font-bold whitespace-nowrap overflow-hidden text-ellipsis">{{ title }}</span>
	</div>
	<!--
		Acción opcional a la altura del título. El bloque de textos es `flex-1`, así
		que lo que se proyecte aquí queda pegado a la derecha.
	-->
	<ng-content select="[sectionHeaderExtra]"></ng-content>
</div>
